import { LoaderCircle } from 'lucide-react';
import '../../assets/loader.css';

export default function Loader() {
	return (
		<div aria-live="polite" aria-busy="true" className="fixed inset-0 z-[999] grid place-items-center overflow-x-hidden bg-slate-950/20 p-4 backdrop-blur-sm">
			<div className="flex max-w-full flex-col items-center gap-3 rounded-xl bg-white px-6 py-5 text-slate-700 shadow-xl">
				<LoaderCircle aria-hidden="true" className="h-8 w-8 animate-spin text-primary" />
				<span className="text-sm font-medium">Loading...</span>
			</div>
		</div>
	);
}
